import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { FaDatabase, FaEdit, FaEye, FaHome, FaIdBadge, FaLock, FaPen, FaPenAlt, FaRegEdit, FaTicketAlt, FaUpload, FaUsers, FaCog, FaFileAlt, FaChartBar, FaBell, FaLink as FaLinkIcon, FaImages } from 'react-icons/fa';
import './sidebar.css'
import { FaFile, FaLink, FaNoteSticky, FaPencil } from 'react-icons/fa6';
import { collapse } from '../redux/reducer/SideBarReducer'
import AxiosInstance from '../Utility/AxiosInstance'
import BaseUrl from '../../base-api'
import { toast } from 'react-toastify'

const Sidebar = () => {
  const dispatch = useDispatch();
  const isCollapsed = useSelector((state) => state.sidebar.value);
  const [privileges, setPrivileges] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleSidebarToggle = () => {
    if (window.innerWidth < 768) {
      dispatch(collapse()) 
    }
  };

  const role = JSON.parse(sessionStorage.getItem("$details"))?.role;

  // Icon mapping for different menu items
  const getIcon = (item) => {
    // Use specific icons based on path or label
    if (item.key?.includes('home') || item.label?.toLowerCase().includes('home')) {
      return <FaHome size={24} className='icon'/>;
    }
    if (item.key?.includes('registration') || item.label?.toLowerCase().includes('registration')) {
      return <FaFile size={24} className='icon'/>;
    }
    if (item.key?.includes('upload') || item.label?.toLowerCase().includes('upload')) {
      return <FaUpload size={24} className='icon'/>;
    }
    if (item.key?.includes('notification') || item.label?.toLowerCase().includes('notification')) {
      return <FaBell size={24} className='icon'/>;
    }
    if (item.key?.includes('link') || item.label?.toLowerCase().includes('link')) {
      return <FaLinkIcon size={24} className='icon'/>;
    }
    if (item.key?.includes('images') || item.label?.toLowerCase().includes('image')) {
      return <FaImages size={24} className='icon'/>;
    }
    if (item.key?.includes('user') || item.label?.toLowerCase().includes('user')) {
      return <FaUsers size={24} className='icon'/>;
    }
    if (item.key?.includes('setting') || item.label?.toLowerCase().includes('setting')) {
      return <FaCog size={24} className='icon'/>;
    }
    if (item.key?.includes('chart') || item.label?.toLowerCase().includes('chart')) {
      return <FaChartBar size={24} className='icon'/>;
    }
    if (item.key?.includes('file') || item.label?.toLowerCase().includes('file')) {
      return <FaFileAlt size={24} className='icon'/>;
    }
    if (item.key?.includes('ticket') || item.label?.toLowerCase().includes('ticket')) {
      return <FaTicketAlt size={24} className='icon'/>;
    }
    if (item.key?.includes('lock') || item.label?.toLowerCase().includes('lock')) {
      return <FaLock size={24} className='icon'/>;
    }
    if (item.key?.includes('edit') || item.label?.toLowerCase().includes('edit')) {
      return <FaEdit size={24} className='icon'/>;
    }
    
    // Default fallback
    return <FaHome size={24} className='icon'/>;
  };

  // Fetch privileges from API
  useEffect(() => {
    const fetchPrivileges = async () => {
      try {
        setLoading(true);
        const response = await AxiosInstance.get(`${BaseUrl}/api/auth/privileges`);
        
        if (response.data && Array.isArray(response.data.privileges)) {
          setPrivileges(response.data.privileges);
        } 
         else {
          console.warn('Unexpected privileges API response:', response.data);
          setPrivileges([]);
        }
      } catch (error) {
        console.error('Failed to fetch privileges:', error);
        toast.error('Failed to load menu privileges');
        // Fallback to empty array on error
        setPrivileges([]);
      } finally {
        setLoading(false);
      }
    };

    if (role) {
      fetchPrivileges();
    } else {
      setLoading(false);
    }
  }, [role]);

  // Filter privileges by role - handle null role (means all roles can access)
  const filteredPrivileges = privileges.filter(privilege => 
    privilege.role === null || privilege.role === role
  );

  if (loading) {
    return (
      <aside className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
        <nav>
          <ul>
            <li className="text-center py-3">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </li>
          </ul>
        </nav>
      </aside>
    );
  }

  return (
    <aside className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <nav>
        <ul>
          {filteredPrivileges.map((item, index) => (
            <li key={index}>
              <Link to={item.key} onClick={handleSidebarToggle}>
                {getIcon(item)}
                {!isCollapsed && <span className='ms-3'>{item.label}</span>}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
}

export default Sidebar
